import { Container } from "pixi.js";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { Trails } from "./Trails";

export class TrailsComponent extends AbstractDisplayComponent {
    public container: Container;

    public override init() {
        let containerConfig = {
            labelName: "trails_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1024,
                posY: 1024,
                scale: 1,
            },
            portrait: {
                posX: 1024,
                posY: 1024,
                scale: 1,
            }
        };

        this.container = new Trails(containerConfig);
    }

    public getInstance(): Container {
        return this.container;
    }

    public triggerTrail(symbol: any, meter: any, callback: () => void) {
        (this.container as Trails).triggerTrail(symbol, meter, callback);
    }

    public override destroy(): void {
        this.container.destroy({ children: true });
    }

}
